<template>
  <div>
    <v-card>
      <v-card-title class="align-baseline">
        <v-layout row wrap>
          <v-flex xs11 sm2>
            <v-menu
              v-model="fromMenu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="from"
                  label="Depuis"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="from"
                type="month"
                no-title
                scrollable
                @input="fetch()"
              />
            </v-menu>
          </v-flex>
          <v-flex xs11 sm2>
            <v-menu
              v-model="toMenu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="to"
                  label="Jusqu'à"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="to"
                type="month"
                no-title
                scrollable
                @input="fetch()"
              />
            </v-menu>
          </v-flex>
          <v-flex xs11 sm2
            ><v-text-field
              v-model="search"
              append-icon="search"
              label="Rechercher par terme"
              single-line
              hide-details
              @input="fetch()"
            ></v-text-field
          ></v-flex>
          <v-flex xs11 sm2>
            <v-text-field
              v-model="id"
              append-icon="search"
              label="Rechercher par identifiant de facture"
              single-line
              hide-details
              @input="fetch()"
            ></v-text-field>
          </v-flex>
          <v-flex xs11 sm1>
            <v-checkbox
              v-model="includeZero"
              label="Zéro inclus"
              @change="fetch"
            />
          </v-flex>
          <v-flex xs11 sm3 class="d-inline-flex justify-end d-flex-initial">
            <v-btn color="primary" @click="download('simple')">
              Simple
              <v-icon right class="hidden-sm-and-down">cloud_download</v-icon>
            </v-btn>
            <v-btn color="primary" @click="download('detailed')">
              Détaillé
              <v-icon right class="hidden-sm-and-down">cloud_download</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="billings"
        :total-items="billingCount"
        class="billing-table"
        :pagination.sync="pagination"
        :rows-per-page-items="[100, 200]"
        :expand="false"
        item-key="_id"
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item._id }}</td>
            <td>{{ props.item.actor.text }}</td>
            <td>{{ props.item.date | shortDate }}</td>
            <td>{{ props.item.total }} €</td>
            <td>{{ props.item.projects.length }}</td>
            <td>
              <v-checkbox
                hide-details
                v-model="props.item.confirmed"
                :readonly="props.item.confirmed"
                @click.native.stop
                @change="confirm(props.item)"
              />
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <BillDataTable
            :billing-entry="props.item"
            :paginate="false"
            :show-total="false"
          />
        </template>
      </v-data-table>
      <v-snackbar v-model="showError" :timeout="7000"
        >Une erreur a eu lieu</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import { fetchHil } from "@/utils";
import * as _ from "lodash";
import { debounce } from "lodash";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { downloadFile } from "../../../../webapp-commons/functions";
import BillDataTable from "../billing/BillDataTable";

export default {
  components: { BillDataTable },
  data() {
    return {
      showError: false,
      loading: false,
      pagination: {
        sortBy: "date",
        descending: true
      },
      includeZero: false,
      search: "",
      id: "",
      from: moment()
        .subtract(1, "months")
        .format("YYYY-MM"),
      to: moment().format("YYYY-MM"),
      fromMenu: false,
      toMenu: false,
      headers: [
        { text: "Référence", value: "_id" },
        { text: "Personne", value: "actor.text" },
        { text: "Date", value: "date" },
        { text: "Total", value: "total" },
        { text: "Nombre de projets", value: "projects.length" },
        { text: "Validé", value: "confirmed" }
      ]
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.fetch();
      }
    }
  },
  computed: {
    ...mapState("admin", ["billings", "billingCount"])
  },
  methods: {
    ...mapActions("admin", ["fetchBillingList", "confirmBilling"]),
    fetch: debounce(
      async function fetch() {
        this.loading = true;
        try {
          const {
            sortBy,
            descending = false,
            page = 1,
            rowsPerPage = 100
          } = this.pagination;
          await this.fetchBillingList({
            skipZero: !this.includeZero,
            from: this.from,
            to: this.to,
            page: page - 1,
            pageSize: rowsPerPage,
            sortBy: sortBy || "_id",
            sortDirection: descending ? "desc" : "asc",
            filter: this.search,
            id: this.id
          });
        } catch {
          this.showError = true;
        }
        this.loading = false;
      },
      300,
      { maxWait: 1e3 }
    ),
    async confirm(billing) {
      try {
        const result = await this.confirmBilling(billing._id);
        if (result.statusCode && result.statusCode !== 200) {
          this.showError = true;
          billing.confirmed = false;
        }
      } catch {
        this.showError = true;
        billing.confirmed = false;
      }
    },
    async download(type = "simple") {
      const qs = new URLSearchParams(
        _.pickBy(
          {
            type,
            filter: this.search,
            id: this.id,
            from: this.from,
            to: this.to
          },
          v => v !== undefined && v !== ""
        )
      );
      const data = await fetchHil(`/reports/billing?${qs}`);
      await downloadFile(data);
    }
  }
};
</script>
